import { render, staticRenderFns } from "./GroupEconomicHandler.vue?vue&type=template&id=a15fdc82"
import script from "./GroupEconomicHandler.vue?vue&type=script&lang=ts"
export * from "./GroupEconomicHandler.vue?vue&type=script&lang=ts"
import style0 from "./GroupEconomicHandler.vue?vue&type=style&index=0&id=a15fdc82&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports